/* eslint-disable no-self-assign */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./SideBar.css";
import { useRol } from '../../Context';
import home from '../../icons/Inicio.svg';
import homeNA from '../../icons/InicioNA.svg';
import lead from '../../icons/Contactos.svg';
import leadNA from '../../icons/ContactosNA.svg';
import task from '../../icons/Tareas.svg';
import taskNA from '../../icons/TareasNA.svg';
import transfer from '../../icons/Transfer.svg';
import transferNA from '../../icons/TransferNA.png';
import project from '../../icons/Proyectos.svg';
import projectNA from '../../icons/ProyectosNA.svg';
import team from '../../icons/Equipo.svg';
import teamNA from '../../icons/EquipoNA.svg';
import analisis from '../../icons/Analisis.svg';
import analisisNA from '../../icons/AnalisisNA.png';
import afinidad from '../../icons/Afinidad.svg';
import afinidadNA from '../../icons/AfinidadNA.png';
import logo from '../../icons/logo-toolbar.png';
import homeMovil from '../../icons/home-outline.svg';
import leadMovil from '../../icons/person-outline.svg';
import taskMovil from '../../icons/calendar-outline.svg';
import logoutMovil from '../../icons/log-out-outline.svg';
import MovilToWeb from '../../icons/open-outline.svg';
import projectMovil from '../../icons/business-outline.svg';
import teamMovil from '../../icons/people-outline.svg';
import analisisMovil from '../../icons/bar-chart-outline.svg';
import afinidadMovil from '../../icons/options-outline.svg';
import tutoriales from '../../icons/graduation-cap-solid.svg';
import tutorialesNA from '../../icons/Imagen5.svg';
import tutorialesMovil from '../../icons/graduation-cap.svg';
import transferMovil from '../../icons/Vector.svg';

function SideBar({ isLeftMenuOpen }) {
    const context = useRol();
    const { rol, staff } = context || {};
    const logout = context?.logout || (() => {
        // Logout function not available
        window.location.href = '/sign-in';
    });

    const menuIconsAsesor = useMemo(() => [
        { activeIcon: home, icon: homeNA, alt: 'Inicio' },
        { activeIcon: lead, icon: leadNA, alt: 'Contactos' },
        { activeIcon: task, icon: taskNA, alt: 'Tareas' },
        { activeIcon: transfer, icon: transferNA, alt: 'Subir-contactos' }
    ], []);

    const menuIconsCoordinador = useMemo(() => [
        { activeIcon: home, icon: homeNA, alt: 'Inicio' },
        { activeIcon: lead, icon: leadNA, alt: 'Contactos' },
        { activeIcon: task, icon: taskNA, alt: 'Tareas' },
        { activeIcon: tutoriales, icon: tutorialesNA, alt: 'Tutoriales' },
        { activeIcon: transfer, icon: transferNA, alt: 'Subir-contactos' },
        { activeIcon: project, icon: projectNA, alt: 'Proyectos' },
        { activeIcon: team, icon: teamNA, alt: 'Equipo' },
        { activeIcon: analisis, icon: analisisNA, alt: 'Analisis' },
        { activeIcon: afinidad, icon: afinidadNA, alt: 'Afinidad' }
    ], []); // Sin dependencias, se calcula solo una vez


    const [isClicked, setIsClicked] = useState(false);

    const handleClick = () => {
        setIsClicked(!isClicked);
    };

    const navigate = useNavigate();

    const handleReload = () => {
        logout();
    };


    const memoizedMenuIconsAsesor = useMemo(() => {
        return menuIconsAsesor.map((item, index) => (
            <NavLink to={`/${item.alt}`} className="bar-select" key={index}>
                <div
                    className={`menu-icon ${window.location.pathname === `/${item.alt}`
                        ? 'active-bar'
                        : ''
                        }`}
                >
                    <img
                        src={window.location.pathname === `/${item.alt}`
                            ? item.activeIcon
                            : item.icon
                        }
                        alt={item.alt}
                    />
                </div>
                <label className={`label-sidebar-v3 ${window.location.pathname === `/${item.alt}`
                    ? 'active-label'
                    : ''
                    }`} >{item.alt.replace(/Subir-contactos/g, 'Transfer')}</label>
            </NavLink>
        ));
    }, [menuIconsAsesor]); // Dependencia: menuIconsAsesor

    const memoizedMenuIconsCoordinador = useMemo(() => {
        return menuIconsCoordinador.filter(item => item.alt !== 'Tutoriales' || staff).map((item, index) => (
            <NavLink to={`/${item.alt}`} className="bar-select" key={index}>
                <div
                    className={`menu-icon ${window.location.pathname === `/${item.alt}`
                        ? 'active-bar'
                        : ''
                        }`}
                >
                    <img
                        src={window.location.pathname === `/${item.alt}`
                            ? item.activeIcon
                            : item.icon
                        }
                        alt={item.alt}
                    />
                </div>
                <label className={`label-sidebar-v3 ${window.location.pathname === `/${item.alt}`
                    ? 'active-label'
                    : ''
                    }`} >{item.alt.replace(/Subir-contactos/g, 'Transfer')}</label>
            </NavLink>
        ));
    }, [menuIconsCoordinador, staff]);

    return (
        <>
            {/* side bar web */}
            <div className="side-bar-web">
                {rol === 'Asesor' && <div>
                    <div className="side-menu">
                        {memoizedMenuIconsAsesor}
                    </div>
                </div>}
                {(rol === 'Coordinador' || rol === 'Supervisor') && <div>
                    <div className="side-menu">
                        {memoizedMenuIconsCoordinador}
                    </div>
                </div>}
            </div>
            {/* side bar movil */}
            {isLeftMenuOpen && (
                <div className="menu-overlay"></div>
            )}
            <div className={`side-menu-movil ${isLeftMenuOpen ? 'open' : 'left'}`}>
                <div className="barra-logo-movil">
                    <img src={logo} alt="logo" />
                    <label>Prospectia</label>
                </div>
                <div className="side-options-movil">
                    <ul className="marca-movil">
                        <li><b>Prospectia</b></li>
                        <li className="dos">CRM Inmobiliario</li>
                    </ul>
                    <ul className="links-movil">
                        {rol === 'Asesor' && <div>
                            <NavLink to={'/Inicio'} className="nav-links-movil">
                                <li className={`cambiarColor ${isClicked ? 'clicked' : ''}`} onClick={handleClick}>
                                    <img src={homeMovil} alt="homeMovil" />
                                    <label>Inicio</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Contactos'} className="nav-links-movil">
                                <li>
                                    <img src={leadMovil} alt="leadMovil" />
                                    <label>Contactos</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Tareas'} className="nav-links-movil">
                                <li>
                                    <img src={taskMovil} alt="taskMovil" />
                                    <label>Tareas</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Subir-contactos'} className="nav-links-movil">
                                <li>
                                    <img src={transferMovil} alt="leadMovil" />
                                    <label>Subir contactos</label>
                                </li>
                            </NavLink>
                        </div>}
                        {(rol === 'Coordinador' || rol === 'Supervisor') && <div>
                            <NavLink to={'/Inicio'} className="nav-links-movil">
                                <li>
                                    <img src={homeMovil} alt="homeMovil" />
                                    <label>Inicio</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Contactos'} className="nav-links-movil">
                                <li>
                                    <img src={leadMovil} alt="leadMovil" />
                                    <label>Contactos</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Tareas'} className="nav-links-movil">
                                <li>
                                    <img src={taskMovil} alt="taskMovil" />
                                    <label>Tareas</label>
                                </li>
                            </NavLink>
                            {staff && <NavLink to={'/Tutoriales'} className="nav-links-movil">
                                <li>
                                    <img src={tutorialesMovil} alt="leadMovil" />
                                    <label>Tutoriales</label>
                                </li>
                            </NavLink>}
                            <NavLink to={'/Subir-contactos'} className="nav-links-movil">
                                <li>
                                    <img src={transferMovil} alt="leadMovil" />
                                    <label>Subir contactos</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Proyectos'} className="nav-links-movil">
                                <li>
                                    <img src={projectMovil} alt="projectMovil" />
                                    <label>Proyectos</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Equipo'} className="nav-links-movil">
                                <li>
                                    <img src={teamMovil} alt="teamMovil" />
                                    <label>Equipo</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Analisis'} className="nav-links-movil">
                                <li>
                                    <img src={analisisMovil} alt="analisisMovil" />
                                    <label>Análisis</label>
                                </li>
                            </NavLink>
                            <NavLink to={'/Afinidad'} className="nav-links-movil">
                                <li>
                                    <img src={afinidadMovil} alt="afinidadMovil" />
                                    <label>Afinidad</label>
                                </li>
                            </NavLink>
                        </div>}
                        <li onClick={handleReload}>
                            <img src={logoutMovil} alt="logoutMovil" />
                            <label>Cerrar Sesión</label>
                        </li>
                    </ul>
                    <ul className="linktoweb-movil">
                        <NavLink to={'https://v3.prospectia.co/'} className="nav-links-movil">
                            <li>
                                <img src={MovilToWeb} alt="MovilToWeb" />
                                <label><b>prospectia.com</b></label>
                            </li>
                        </NavLink>
                    </ul>
                </div>
            </div>
        </>
    )
}

export { SideBar }